import { useNavigate } from "react-router-dom";
import { Home } from "lucide-react";

export default function NotFound() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen grid place-items-center bg-[#F4F6F4] p-4">
      <div className="text-center space-y-4">
        <h1 className="font-serif text-[48px] font-semibold">Nothing here</h1>
        <p style={{ color: "var(--text-muted)" }}>This page took a quiet day off. Let's head back home.</p>
        <button className="btn btn-primary mx-auto" onClick={() => nav("/")}><Home size={16} /> Back home</button>
      </div>
    </div>
  );
}
